import { Base } from './base.js';
import { Events } from './events/events.js';
import { Roles } from './user/roles.js';
import { Actions } from './actions/actions_enum.js';

export {
  Base,
  Events,
  Roles,
  Actions
};


// Mandamos el evento de inicialización
async function tbf_bootstrap() {
  while (true) {
    if (window.tbfront_ready) {
      try {
        window.tbfront_ready();
      } catch (e) { } // Si falla, ignoramos para no repetir masivamente el inicio

      break;
    }
    await new Promise(r => setTimeout(r, 100));
  }
}

tbf_bootstrap();